
//Représente les paramètres de mise à jour du groupe des colonnes d’un utilisateur
export class ASeMettreAJourGroupeColonnesUtilisateurParametres 
{
  //Création
  constructor () 
  {
    this.groupesColonnes = [];
  }

  //Identifiant de l’onglet
  public identifiantOnglet!: string;

  //Groupes des colonnes
  public groupesColonnes: ASeGroupeColonne[];
}

//Représente le groupe d’une colonne
export class ASeGroupeColonne 
{
  //Identifiant
  public identifiant!: string;

  //Ordre
  public ordre!: number;

  //Sens du tri
  public sens!: string;
}
